import { StaffingPartnerList } from '@libs/models/staffingPartners';
import { PaginatedResponse } from '@libs/models/common';
import { request } from '../request';
import { filterToQueryParams } from '../utils';
import { Filter } from '@libs/store/filters';

type fetchStaffingPartnersListParams = {
  search?: string;
  page?: number;
  size?: number;
  filters?: Record<string, Filter>;
};
export async function fetchStaffingPartnersList(
  params?: fetchStaffingPartnersListParams,
): Promise<PaginatedResponse<StaffingPartnerList[]>> {
  const filters = filterToQueryParams(params?.filters ?? {}, {removeEmpty: true, renameMap:{
    locations: 'location',
    statuses: 'status',
    relations: 'relation',
    regions: 'region',
  }});

  const response = await request.get<PaginatedResponse<AgenciesResponseItem[]>>('/v2/agencies', {
    params: { pageNumber: 1, pageSize: 60, search: params?.search || undefined, ...filters },
  });
  return {
    pageNumber: 1,
    pageSize: 60,
    totalCount: 60,
    items: response.data.items.map((item, idx) => ({
      id: item.id
        ? item.id
        : `${item.name}_${item.mainContact.email}_${item.regions.join(', ')}_${item.mainContact.phoneNumber}_${item.address.firstAddress}_${+new Date()}${idx}`,
      name: item.name,
      icon: item.logoUrl,
      region: item.regions.join(', '),
      contact: {
        email: item.mainContact.email,
        name: item.mainContact.name,
        phoneNumber: item.mainContact.phoneNumber,
        title: item.mainContact.title,
        secondaryPhoneNumber: item.mainContact.secondaryPhoneNumber,
      },
      address: {
        firstAddress: item.address.firstAddress,
        city: item.address.city,
        state: item.address.state,
        zipCode: item.address.zipCode,
        secondAddress: item.address.secondAddress,
      },
      locations: item.sharedAgencyLocations
        ? item.sharedAgencyLocations.map((location) => ({
            id: location.id,
            name: location.name,
          }))
        : [],
      relationType: item.relationType,
      invitationStatus: item.status,
      partnerUrl: item.id,
    })),
  };
}

type AgenciesResponseItem = {
  id: string;
  name: string;
  regions: string[];
  logoUrl: string;
  mainContact: {
    email: string;
    name: string;
    phoneNumber: string;
    title: string;
    secondaryPhoneNumber: string;
  };
  address: {
    firstAddress: string;
    city: string;
    state: string;
    zipCode: string;
    secondAddress: string;
  };
  sharedAgencyLocations: {
    id: string;
    name: string;
  }[];
  relationType: 'Direct' | 'Managed';
  status: 'Pending' | 'Disconnected' | 'Active' | 'OnReview';
};
